import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export async function updateTaskById(data: object, taskId: string) {
  const path = `/v1/task/${taskId}/update`;
  const url = `${TASKS_SERVICE_URL}${path}`;
  const { result } = await fetchAPI("PUT", url, data, "json");
  return result;
}

export function useUpdateTaskMutation(
  ignoreInvalidateByTaskId?: boolean,
  taskId?: string
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["updateTask", taskId],
    mutationFn: (data: { data: object; taskId: string }) => {
      return updateTaskById(data.data, data.taskId);
    },
    onSuccess: async (data) => {
      if (data) {
        const taskId = data?.id;
        if (!ignoreInvalidateByTaskId) {
          await queryClient.invalidateQueries({
            queryKey: ["task", "id", taskId, data.task_type],
          });
        }
        queryClient.invalidateQueries({
          queryKey: ["task", "activities", taskId],
        });
      }
    },
    onError: (error) => {
      console.log("Error while updating task", error);
    },
  });
}
